import { css } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
import classNames from 'classnames';
const bestOfTag = "b1y8e1q1";
export const BestOfTag = ({
  children
}) => <div className={classNames(buttonReset, tagBase, bestOfTag)}>{children}</div>;

require("../../../.linaria-cache/src/components/tags/tag-best-of.linaria.module.css");